import { ColorNordicGrey1, Spacing48, Spacing4 } from 'autogen/design-tokens/tokens';
import { rem } from 'modules/helpers/style';
import { css } from 'styled-components';

const chanelTheme = {
    Wrapper: css`
        border-top: 1px solid ${ColorNordicGrey1};
        border-bottom: 1px solid ${ColorNordicGrey1};
        font-family: Arial, Helvetica, sans-serif;
        font-size: ${rem(14)};
        margin-top: ${Spacing48};
        margin-bottom: ${Spacing48};
    `,
    StyledPictureWithLink: css`
        display: none;
    `,
    ProductAccordionItem: {
        AccordionButton: css`
            padding-left: 0;
            padding-right: 0;
        `,
        ContentContainer: css`
            padding-left: 0;
            padding-right: 0;
        `,
        StyledBody: css`
            text-transform: uppercase;
            font-size: ${rem(14)};
            font-family: inherit;
        `
    },
    TabBlock: {
        StyledButton: css`
            font-weight: normal;
        `
    },
    Table: {
        StyledCard: css`
            background: transparent;
        `,
        StyledCardContent: css`
            padding: 0;
        `,
        StyledBody: css`
            text-transform: uppercase;
        `,
        StyledTable: css`
            tr {
                border: 0;
            }
            td,
            th {
                font-weight: normal;
                padding-top: 0;
                padding-bottom: ${Spacing4};

                &:first-child,
                &:last-child {
                    text-align: left;
                }
            }
            a {
                font-weight: normal;
            }
        `
    }
};

export default chanelTheme;
